var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
      staticClass: "pb-10",
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Proveedores",
          breadcrumbs: _vm.breadcrumbs,
          dense: true,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("v-text-field", {
                  staticClass: "mx-2 input-custom-height",
                  staticStyle: { "min-width": "300px", "max-width": "300px" },
                  attrs: {
                    placeholder: `Introduce el ${_vm.$t(
                      "generals.RUT"
                    )} o razón social`,
                    outlined: "",
                    "single-line": "",
                    dense: "",
                    maxlength: "60",
                    "hide-details": "",
                  },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchSupplier.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.search.length > 0
                        ? {
                            key: "append",
                            fn: function () {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mr-n2",
                                    attrs: { text: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.resetSearch.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { color: "grey-900" },
                                      },
                                      [_vm._v("mdi-close")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "search",
                  },
                }),
                _c("v-query-builder", {
                  staticClass: "mr-2",
                  attrs: {
                    "query-map": _vm.filters,
                    model: "suppliers",
                    active: _vm.activeFilter,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.activeFilter = $event
                    },
                  },
                }),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "grey-900" },
                    on: {
                      click: function ($event) {
                        _vm.dialogSupplier = true
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-human-dolly"),
                    ]),
                    _vm._v("Crear proveedor"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-20", attrs: { cols: "12" } },
        [
          _vm.loading
            ? _c("skeleton-list")
            : [
                _c("SupplierList", {
                  attrs: {
                    "suppliers-list": _vm.list,
                    reset: _vm.reset,
                    "reset-scroll": _vm.resetScroll,
                    "use-infinite-scroll": true,
                    "show-category-column":
                      _vm.$store?.state?.auth?.account?.options?.includes(
                        "rec_process_rules"
                      ),
                    "has-more-data": !!_vm.nextToken,
                    "empty-title": "No existen proveedores para mostrar",
                  },
                  on: {
                    delete: function ($event) {
                      return _vm.handleTableAddToGroup($event, "delete")
                    },
                    add: function ($event) {
                      return _vm.handleTableAddToGroup($event, "add")
                    },
                    change: function ($event) {
                      return _vm.handleTableAddToGroup($event, "change")
                    },
                    "load-more": _vm.loadMore,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "empty-actions",
                      fn: function () {
                        return [
                          !_vm.$route.query.ordering && _vm.hiddenBtnEmpty
                            ? [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "grey-900",
                                      ripple: false,
                                      width: 153,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.activeFilter = true
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-2" }, [
                                      _vm._v("mdi-filter-plus"),
                                    ]),
                                    _vm._v("Filtrar"),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      outlined: "",
                                      ripple: false,
                                      width: "153",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.latestRecords()
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-2" }, [
                                      _vm._v("mdi-text-search-variant"),
                                    ]),
                                    _vm._v("Últimos registros"),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
        ],
        2
      ),
      _vm.$store?.state?.auth?.account?.options?.includes("rec_process_rules")
        ? _c("SupplierCategoryModal", {
            attrs: {
              "action-type": _vm.actionType,
              supplier: _vm.current,
              "categories-list": _vm.segmentsList,
              loading: _vm.createGroupLoading,
            },
            on: { confirm: _vm.handleCategoryConfirm },
            model: {
              value: _vm.dialogAddGroup,
              callback: function ($$v) {
                _vm.dialogAddGroup = $$v
              },
              expression: "dialogAddGroup",
            },
          })
        : _vm._e(),
      _vm.$store?.state?.auth?.account?.options?.includes("rec_process_rules")
        ? _c("SupplierDeleteCategoryModal", {
            attrs: { supplier: _vm.current },
            on: { confirm: _vm.handleDeleteConfirm },
            model: {
              value: _vm.dialogDelete,
              callback: function ($$v) {
                _vm.dialogDelete = $$v
              },
              expression: "dialogDelete",
            },
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogExport,
            callback: function ($$v) {
              _vm.dialogExport = $$v
            },
            expression: "dialogExport",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Descarga de proveedores")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogExport = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-2" },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "pt-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text body-1 font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    "Selecciona el formato de los archivos:"
                                  ),
                                ]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ml-n1",
                                      attrs: { "no-gutters": "" },
                                    },
                                    _vm._l(_vm.fileFormat, function (file) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: file,
                                          staticClass: "pa-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              "input-value":
                                                _vm.types.includes(file) ||
                                                false,
                                              column: "",
                                              label: file,
                                              disabled:
                                                ["XLSX", "CSV"].includes(
                                                  file
                                                ) && _vm.count >= 1000000,
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getFileFormat(file)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialogExport = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        ripple: false,
                        disabled: !_vm.types.length,
                      },
                      on: { click: _vm.createExport },
                    },
                    [_vm._v("Descargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogSupplier,
            callback: function ($$v) {
              _vm.dialogSupplier = $$v
            },
            expression: "dialogSupplier",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Crear proveedor")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogSupplier = false),
                                        _vm.clearInput()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "py-4 px-0 overflow-y-auto",
                  staticStyle: { "max-height": "710px" },
                  attrs: { "min-height": "700", scrollable: "" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "font-weight-semibold d-flex align-center subtitle-2 px-5 text-500--text",
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "grey-500", size: "18", left: "" } },
                        [_vm._v("mdi-human-dolly")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Información del proveedor")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "3" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                          ]),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "dni",
                                rawName: "v-dni",
                                value: _vm.newSupplier.country,
                                expression: "newSupplier.country",
                              },
                            ],
                            attrs: {
                              error: _vm.$v.newSupplier.tax_id.$error,
                              required: "",
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.newSupplier.tax_id.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newSupplier.tax_id,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.newSupplier.tax_id.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Nombre de la empresa"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.newSupplier.name.$error,
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "100",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.newSupplier.name.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newSupplier.name,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.newSupplier.name.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-5" },
                    [
                      _c("span", { staticClass: "grey-500--text body-1" }, [
                        _vm._v("Actividad económica"),
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          "single-line": "",
                          dense: "",
                          maxlength: "64",
                          "hide-details": "",
                        },
                        model: {
                          value:
                            _vm.newSupplier.tax_settings
                              .cl_activity_description,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newSupplier.tax_settings,
                              "cl_activity_description",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression:
                            "newSupplier.tax_settings.cl_activity_description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5 pb-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "8" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Dirección"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "64",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.newSupplier.address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newSupplier,
                                  "address",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "newSupplier.address",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v(_vm._s(_vm.$t("generals.Comuna"))),
                          ]),
                          _c("v-select", {
                            attrs: {
                              label: _vm.$t("generals.Selecciona una comuna"),
                              items: _vm.$store.getters["base/currentStates"],
                              "item-value": "name",
                              "item-text": "name",
                              "single-line": "",
                              "hide-details": "",
                              dense: "",
                              height: "30",
                              outlined: "",
                              "no-data-text": `No existen ${_vm.$t(
                                "generals.Comuna"
                              )} para el pais.`,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "font-weight-regular" },
                                      [_vm._v(_vm._s(data.item.name))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.newSupplier.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.newSupplier, "state", $$v)
                              },
                              expression: "newSupplier.state",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.$store?.state?.auth?.account?.options?.includes(
                    "rec_process_rules"
                  )
                    ? [
                        _c("v-divider", { staticClass: "my-4" }),
                        _c(
                          "div",
                          { staticClass: "px-5 pt-1" },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "px-0 mb-3 d-flex align-center" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-500",
                                      size: "18",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-account-multiple")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "subtitle-2 grey-500--text font-weight-semibold",
                                  },
                                  [
                                    _vm._v(
                                      "Selecciona la categoría a la que quieres asignar al proveedor"
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass:
                                      "ml-2 px-1 font-weight-regular",
                                    attrs: {
                                      "x-small": "",
                                      color: "grey-background",
                                    },
                                  },
                                  [_vm._v("Opcional")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "pa-0" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "grey-500--text body-1" },
                                  [_vm._v("Categorías")]
                                ),
                                _c(
                                  "v-col",
                                  { staticClass: "pa-0" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        "hide-details": "",
                                        "single-line": "",
                                        color: "green-500",
                                        dense: "",
                                        outlined: "",
                                        items:
                                          _vm.filteredSegmentsListForCreate,
                                        chips: false,
                                        "item-text": "name",
                                        "item-value": "id",
                                        "item-disabled": "disabled",
                                        "no-data-text":
                                          "No existen categorías para mostrar",
                                        "menu-props": {
                                          bottom: true,
                                          offsetY: true,
                                          maxHeight: 200,
                                        },
                                      },
                                      model: {
                                        value: _vm.newSupplier.segment_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newSupplier,
                                            "segment_id",
                                            $$v
                                          )
                                        },
                                        expression: "newSupplier.segment_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogSupplier = false), _vm.clearInput()
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.$store.state.suppliers.createLoader,
                      },
                      on: { click: _vm.postSupplier },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }